<div *ngIf="itemsSize" class="jinni-carousel row bgc-white">
  <div class="px-sm-only-0 container xl-12 md-12 sm-12 xs-12">
    <div class="carousel-container" [ngClass]="{'done': done}">
      <div class="d-flex justify-content-between align-items-center mt-5 pt-4">
        <h1 class="color-prussian-blue px-3">
          <span *ngIf="this.packageType.param == this.packageTypes.single.param">{{ 'carousel.single' | translate }}</span>
          <span *ngIf="this.packageType.param == this.packageTypes.teamPlay.param">{{ 'carousel.teamPlay' | translate }}</span>
          <span *ngIf="this.packageType.param == this.packageTypes.bundle.param">{{ 'carousel.bundle' | translate }}</span>
        </h1>
        <span>
          <a *ngIf="packageType.param != packageTypes.bundle.param" [routerLink]="['/' + showLang, 'lotteries']"
             [queryParams]="packageType.param == packageTypes.teamPlay.param ? {'type': 'group'} : {'': ''}"
             class="tt-capitalize font-proximanova color-cornflower-blue fz-14px me-3">
            {{ 'carousel.seeMore' | translate }}
            <span *ngIf="this.packageType.param == this.packageTypes.single.param">{{ 'carousel.single' | translate }}</span>
            <span *ngIf="this.packageType.param == this.packageTypes.teamPlay.param">{{ 'carousel.teamPlay' | translate }}</span>
            <span *ngIf="this.packageType.param == this.packageTypes.bundle.param">{{ 'carousel.bundle' | translate }}</span>
          </a>
          <a *ngIf="packageType.param == packageTypes.bundle.param" [routerLink]="['/' + showLang, 'packages']"
             [queryParams]="packageType.param == packageTypes.teamPlay.param ? {'type': 'group'} : {'': ''}"
             class="tt-capitalize font-proximanova color-cornflower-blue fz-14px me-3">
            {{ 'carousel.seeMore' | translate }}
            <span *ngIf="this.packageType.param == this.packageTypes.single.param">{{ 'carousel.single' | translate }}</span>
            <span *ngIf="this.packageType.param == this.packageTypes.teamPlay.param">{{ 'carousel.teamPlay' | translate }}</span>
            <span *ngIf="this.packageType.param == this.packageTypes.bundle.param">{{ 'carousel.bundle' | translate }}</span>
          </a>
          <img class="me-3 position-relative t2px h11px" src="../../assets/icons/double_arrow.png" alt="">
        </span>
      </div>
      <owl-carousel *ngIf="itemsSize"
                    [options]="{dotsEach: true, nav: false, checkVisible: true, lazyLoad: true, stageElement: disable, autoWidth: false, responsiveClass: true, responsive:{
                            '0':{ items:2 },
                            '1200':{ items:3 }
                            }}"
                    [items]="itemsArr"
                    [carouselClasses]="['owl-carousel','owl-theme','owl-drag', 'row']">
        <div class="item" *ngFor='let in of counter(itemsSize) ;let i = index'>
          <div class="slide pb-3 pb-sm-0 package-{{ valueOfIndex(i,'Name') }} lottery-{{ valueOfIndex(i,'urlLotteryName') }}">
            <div class="d-flex flex-column justify-content-center lottery-top pb-sm-5">
              <div class="fz-14px fz-sm-16px ms-0 name pe-5 pe-sm-2 px-2 py-0 text-start">{{ valueOfIndex(i, 'DisplayName') }}</div>
              <div class="award fz-14px fz-sm-18px ms-2 text-start">
                <span
                  *ngIf="currency && currency.Code && itemsArr[i]['OnlinePrice']">
                   {{itemsArr[i].Rates.TotalJackpotAmount[currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):currency.Symbol:showLang:false}}
                </span>
              </div>
            </div>
            <div class="logo-bg d-none"></div>
            <div class="lottery-bg box-shadow-basic {{itemsArr[i]['BackgroundColor']}} blue"></div>
            <!--            todo:remove later  -->
            <!--            <img class="logo-icon" src="../../../assets/images/bundles/{{itemsArr[i]['IconName']}}/{{itemsArr[i]['IconName']}}-icon.png" style="width: 100px;">-->
            <div class="left-unset logo-icon me-2 me-sm-3 r-0"></div>
            <div class="lottery-bottom">
              <div *ngIf="packageType.param == packageTypes.single.param" class="przycisk bgc-malachite medium btn-playnow w-inherit" [routerLink]="['/' + showLang, 'lotteries', valueOfIndex(i,'urlLotteryName')]">
                {{ 'bundles.getIt'| translate}} {{itemsArr[i].Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}
                <a class="tt-capitalize fw-400">
                  {{ 'carousel.betNow' | translate }}
                </a>
              </div>
              <div *ngIf="packageType.param == packageTypes.teamPlay.param" class="przycisk bgc-malachite medium btn-playnow w-inherit" [routerLink]="['/' + showLang, 'lotteries', valueOfIndex(i,'urlLotteryName')]" [queryParams]="{group: ''}">
                {{ 'bundles.getIt'| translate}} {{itemsArr[i].Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}
                <a class="tt-capitalize fw-400">
                  {{ 'carousel.betNow' | translate }}
                </a>
              </div>
              <div *ngIf="packageType.param == packageTypes.bundle.param" class="przycisk bgc-malachite medium btn-playnow w-inherit" (click)="showBundleDetailPopup(itemsArr[i])">
                {{ 'bundles.getIt'| translate}} {{itemsArr[i].Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}
                <a class="tt-capitalize fw-400">
                  {{ 'carousel.betNow' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </owl-carousel>
    </div>
  </div>
</div>
<package-details-popup
  *ngIf="packageType.param == packageTypes.bundle.param"
  [item]="currentPackageToRenderDetails"
  [showDetails]="showPackageBundleDetailsPopup"
  (onVisibleChange)="onChangePopupVisibility($event)"
>
</package-details-popup>

